import I9DocumentList from './I9DocumentList.vue';

export default I9DocumentList;


// WEBPACK FOOTER //
// ./src/components/ESSProfile/ESSComponents/I9DocumentList/index.js